import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { showInfoToast, showSuccessToast } from "../../components/Toast";
import { readPendingTopUp } from "../checkout/topUpReturn";
import { referenceFromLocation } from "../checkout/paystackReturn";
import useFinanceTopUp from "./useFinanceTopUp";
import FinanceShell from "./components/FinanceShell";
import FinanceEmptyState from "./components/FinanceEmptyState";
import { SummaryLinesSkeleton } from "./components/FinanceSkeletons";
import { FINANCE_COPY, toppedUpMessage } from "./financeCopy";
import { TOP_UP_CURRENCY, moneyOf } from "./financeMoney";
import { FINANCE_PATH } from "./financeRoutes";

import "../checkout/styles.css";
import "./styles.css";

const TopUpReturnRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const topUp = useFinanceTopUp();

  const [failed, setFailed] = useState(false);
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;

    startedRef.current = true;

    const pending = readPendingTopUp();
    const reference = referenceFromLocation(location.search) || pending?.reference;

    if (!reference) {
      setFailed(true);

      return;
    }

    const settle = async () => {
      const outcome = await topUp.confirm({
        reference,
        amount: pending?.amount ?? null,
        currencyCode: pending?.currencyCode || TOP_UP_CURRENCY,
        balanceBefore: pending?.balanceBefore ?? null,
      });

      if (outcome.status === "credited") {
        showSuccessToast(
          outcome.amount?.value != null
            ? toppedUpMessage(moneyOf(outcome.amount.value, outcome.amount.currency))
            : "Your wallet has been topped up.",
          "Wallet Topped Up"
        );
      } else {
        showInfoToast(FINANCE_COPY.topUpPending.message, FINANCE_COPY.topUpPending.title);
      }

      navigate(FINANCE_PATH, { replace: true });
    };

    settle();
  }, [location.search, navigate, topUp]);

  return (
    <FinanceShell title="Finishing your top-up" backTo={FINANCE_PATH}>
      <section className="sy-flow-card">
        <div className="sy-flow-card-body">
          {failed ? (
            <FinanceEmptyState
              inline
              state={{
                title: "Nothing to confirm",
                body: "We could not find a top-up to finish. Your balance is unchanged.",
              }}
              onRetry={() => navigate(FINANCE_PATH, { replace: true })}
              retryLabel="Back to Finance"
            />
          ) : (
            <>
              <p className="fin-field-hint">
                Checking with Paystack — this only takes a moment.
              </p>

              <SummaryLinesSkeleton lines={3} />
            </>
          )}
        </div>
      </section>
    </FinanceShell>
  );
};

export default TopUpReturnRoute;
